import { i18n_config_default } from './chunk-EJ2TIXJU.mjs';
import { __async } from './chunk-T36PI2YV.mjs';
import max from 'lodash/max';
import min from 'lodash/min';

var calculatePriceText = (inputPrices) => inputPrices.length === 1 ? formatMoney(null, inputPrices[0]) : `${formatMoney(null, min(inputPrices))} - ${formatMoney(null, max(inputPrices))}`;
var numberFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD"
});
var formatMoney = (currency, number = 0) => {
  const amount = number != null ? number : 0;
  if (currency) {
    return i18n_config_default.t("currency", { val: amount, currency });
  } else {
    return numberFormatter.format(amount);
  }
};
function base64File(url) {
  return __async(this, null, function* () {
    const data = yield fetch(url);
    const blob = yield data.blob();
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = () => {
        const base64data = reader.result;
        resolve(base64data);
      };
    });
  });
}
function getURLStringOrBase64(url) {
  return __async(this, null, function* () {
    if (url === null)
      return Promise.resolve(null);
    if (url.trim().length === 0)
      return Promise.resolve(null);
    if (url.startsWith("http") || url.startsWith("data"))
      return Promise.resolve(url);
    if (url.startsWith("file") || url.startsWith("blob")) {
      const base64String = yield base64File(url);
      return Promise.resolve(base64String.split("base64,")[1]);
    }
    return Promise.resolve(url);
  });
}
var onValidate = (onSuccess) => onSuccess();
var not = (fn) => (t) => !fn(t);
var and = (...fns) => (t) => fns.reduce((acc, fn) => acc && fn(t), true);

export { and, base64File, calculatePriceText, formatMoney, getURLStringOrBase64, not, onValidate };
